<template>
    <rkm-area
        background-color="secondary"
        title="Desfecho"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group
                    :validations="{required: true}"
                    class="mt-1 mb-2"
                    name="Desfecho"
                    v-model="model.desfecho.finalizado"
                >
                    <rkm-form-radio :value="true">Liberar paciente</rkm-form-radio>
                    <rkm-form-radio :value="false">Manter no mesmo setor</rkm-form-radio>
                    <rkm-form-radio :value="'encaminhar'">Encaminhar para outro setor</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="model.desfecho.finalizado === 'encaminhar'">
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.desfecho.centrosCustoEncaminhamento"
                    :validations="{required: true}"
                    label="Setor de Encaminhamento"
                    show-default-option
                    text-field="setorNome"
                    v-model="model.desfecho.centroCustoEncaminhamentoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    props: {
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
}
</script>
